<template>
  <v-app id="inspire">

    <v-app-bar
        app
        class="hide-on-print"
        clipped-right
        color="blue darken-3" dark
        fixedcle
    >

      <v-toolbar-title class="ml-0 " style="  display: flex; align-items: center;">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
        <img height="50" src="../../public/logo-with-bg.png">
        <h4 class="hidden-sm-and-down ml-1">Administrative Portal</h4>
      </v-toolbar-title>
      <div class="d-flex align-center mx-auto col-md-3 col-sm-5 col-xs-4 py-0">
        <v-text-field
            flat
            style="height: 58px;"
            hide-details
            placeholder="Search By Document Number"
            prepend-inner-icon="filter_list"
            outlined
            autofocus
            v-model="document_number"
            @keypress.enter="openTravellerDocuments"
        />
        <v-btn
            class="mx-2 search-btn-for-sm"
            fab
            dark
            small
            color="primary"
            elevation="0"
            @click="openTravellerDocuments"
        >
          <v-icon dark>
            mdi-magnify
          </v-icon>
        </v-btn>
      </div>
      <v-icon class="white--text">mdi-account-circle</v-icon>
      <h4 class="hidden-sm-and-down ml-1">{{ user.full_name }}<br><h6>({{ roles }})</h6></h4>




      <div v-if="user.automation_enabled && (assignedVisas.length || assignedTrekkingRequestsTotal)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon large class="ml-4 mr-3 notify-bell" v-on="on"
                   @click="notificationDrawer = !notificationDrawer">
              <v-badge color="green" overlap :content="assignedVisas.length + assignedTrekkingRequestsTotal">
                <v-icon>mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>Assigned Visas</span>
        </v-tooltip>

        <portal to="notification">
          <v-flex class="d-flex align-center justify-space-between my-3 px-4">
            <v-btn
                :loading="loading"
                class="mr-3 elevation-0"
                color="primary"
                no-caps
                outlined
                @click="refreshNotification"
            >
              Refresh
              <v-icon right dark>mdi-sync</v-icon>
            </v-btn>
          </v-flex>
          <v-divider/>

          <v-tabs
              fixed-tabs
              background-color="primary"
              dark
              v-model="notificationTab"
          >
            <v-tab v-if="user.automation_enabled" href="#visas">Visas ({{ assignedVisasTotal }})</v-tab>
            <v-tab v-if="user.automation_trekking" href="#trekkings">Trekking ({{
                assignedTrekkingRequestsTotal
              }})
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="notificationTab">
            <v-tab-item value="visas">
              <v-list>
                <template v-for="(item,index) in assignedVisas">
                  <v-list-item
                      :key="index"
                      @click="viewVisaRequest(item)"
                      ripple
                      class="cursor-pointer align-center"
                  >
                    <v-list-item-icon class="mr-5 align-self-center">
                      <v-icon :color="isDateToday(item.assigned_date) ? 'green' : ''">mdi-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="mb-1">
                        <span class="">Submission No: </span>
                        <span class="font-weight-bold ml-1">{{ item.submission_no }}</span>
                        <span class="text-caption text--secondary float-right">{{ item.assigned_date }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        <div class="mb-1">
                          <span class="">Purpose: <span class="text-black">{{ item.purpose }}</span></span>
                        </div>
                        <div class="mb-1">
                          <span class="">Traveller: <span class="text-black">{{ item.traveller }}</span>
                            <span v-if="item.document_number" class="ml-2">- {{ item.document_number }}</span>
                          </span>
                        </div>
                        <div>
                          <span class="">Assigned by: <span class="text-black">{{ item.assigned_by }}</span></span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>
                </template>
              </v-list>
            </v-tab-item>

            <v-tab-item value="trekkings">
              <v-list>
                <template v-for="(item,index) in assignedTrekkingRequests">
                  <v-list-item
                      :key="index"
                      v-if="item.assignment"
                      @click="viewTrekkingRequest(item)"
                      ripple
                      class="cursor-pointer align-center"
                  >
                    <v-list-item-icon class="mr-5 align-self-center">
                      <v-icon :color="isDateToday(item.assignment.created_at) ? 'green' : ''">mdi-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="mb-1">
                        <span class="">Submission No: </span>
                        <span class="font-weight-bold ml-1">T{{ item.id }}</span>
                        <span class="text-caption text--secondary float-right">{{ item.assignment.created_at }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        <div class="mb-1">
                          <span class="">Route: <b>{{ item.trekking_route }}</b></span>
                        </div>
                        <div class="mb-1">
                          <span class="">Purpose: <b>{{ item.assignment.purpose_name }}</b></span>
                        </div>
                        <div>
                          <span class="">Assigned by: <b>{{ item.assignment.assigned_by.name }}</b></span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>
                </template>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </portal>
      </div>

      <v-menu :nudge-bottom="10" bottom class="mr-2" left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-on="on">
            <v-icon>mdi-settings</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
              :disabled="item.disabled"
              :href="item.href"
              :key="index"
              :target="item.target"
              @click="item.click"
              rel="noopener"
              ripple="ripple"
              v-for="(item,index) in itemSide"
              v-if="item.show"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        v-model="notificationDrawer"
        right
        app
        width="450"
        @input="handleClose"
        temporary
    >
      <div class="">
        <portal-target name="notification">
        </portal-target>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
        v-model="filterDrawer"
        right
        app
        width="300"
        @input="handleClose"
        temporary
    >
      <div class="mt-12">
        <portal-target name="destination">
        </portal-target>
      </div>

    </v-navigation-drawer>
    <v-navigation-drawer
        app
        class="hide-on-print"
        expand-on-hover
        v-if="!password_change_required"
        v-model="drawer"
        width="300">
      <v-list class="pt-0" dense>
        <template v-for="item in items">
          <v-list-group
              :append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
              :key="item.text"
              :prepend-icon="item.icon"
              v-if="showChild(item)"
              v-model="item.model"
          >
            <v-list-item slot="activator" style="padding-left: 0">
              <v-list-item-content style="margin-left: -13px">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-for="(child, i) in item.children">
              <v-list-item :key="i" :to="child.to"
                           @click="routeTo(child.to,child.params)" style="padding-left: 30px;"
                           v-if="showMenu(child)">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <template v-if="!showChild(item) && $oauth.checkIfHasPermission(item.checkPermission)">
            <v-list-item :key="item.text" :to="item.to">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content style="margin-left: -13px;">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <print-dialog/>

    <v-content class="px-5 py-2" v-if="password_change_required">
      <password-first-change/>
    </v-content>
    <v-content class="px-5 py-2" v-else>
      <transition>
        <keep-alive>
          <router-view/>
        </keep-alive>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OAuth from "../oauth";
import {API_URL, VERSION} from "../config/config.js";
import Http from "axios";
import PrintDialog from "../components/dialogs/PrintDialog";
import PasswordFirstChange from "../views/acl/user/PasswordFirstChange";
import moment from "moment";
import {isSameDay} from "date-fns";

let oAuth = new OAuth();

export default {
  components: {PasswordFirstChange, PrintDialog},
  data: () => ({
    itemSide: [],
    dialog: false,
    drawer: null,
    notificationTab: null,
    notificationDrawer: null,
    assignedVisasTotal: 0,
    assignedTrekkingRequestsTotal: 0,
    items: [
      {
        text: "Dashboard",
        to: {name: "Dashboard"},
        icon: "dashboard",
        checkPermission: ["read dashboard"],
      },
      {
        text: "ETA Dashboard",
        to: {name: "EtaDashboard"},
        icon: "mdi-view-dashboard-variant",
        checkPermission: ["read eta-dashboard"],
      },
      {
        text: "Visa Request Search",
        to: {name: "BarCode"},
        icon: "mdi-barcode",
        checkPermission: ["read visa-request"],
      },
      {
        icon: "mdi-equal-box",
        text: "Visa Requests",
        model: false,
        children: [
          {
            text: "Pre-Arrival Visa",
            to: {name: "PreArrivalVisaRequest"},
            checkPermission: ["read visa-request"],
            icon: "mdi-alpha-g",

          },
          {
            text: "Applied Visa",
            to: {name: "VisaRequest"},
            checkPermission: ["read visa-request"],
            icon: "mdi-alpha-g",

          },
          {
            text: "Eta Visa Request",
            to: {name: "EtaVisaRequest"},
            checkPermission: ["read eta-visa-request"],
            icon: "mdi-alpha-e",
          },
          {
            icon: "mdi-file-cancel-outline",
            text: "Visa Application Verified",
            to: {name: "VisaVerifiedReport"},
            checkPermission: ["read verified-visa"]
          },
          {
            icon: "mdi-file-cancel-outline",
            text: "Paid Visa",
            to: {name: "VisaPaidReport"},
            checkPermission: ["read paid-visa"]
          }
        ]
      },
      {
        icon: "mdi-equal-box",
        text: "Transfer & Upgrade",
        model: false,
        children: [
          {
            text: "Visa Transfer",
            to: {name: "VisaTransfer"},
            icon: "mdi-transfer",
            checkPermission: ["read visa-transfer"],
          },
          {
            text: "Visa Plan upgrade",
            to: {name: "VisaPlanUpgrade"},
            icon: "mdi-file-upload",
            checkPermission: ["read plan-upgrade"],
          }
        ]
      },
      {
        icon: "mdi-alpha-c-box",
        text: "Certifications",
        model: false,
        children: [
          {
            text: "Arrival Certifications",
            to: {name: "ArrivalCertification"},
            checkPermission: ["read certification"],
            icon: "mdi-alpha-a-box",
          },

          {
            text: "Departure Certifications",
            to: {name: "DepartureCertification"},
            icon: "mdi-alpha-d-box",
            checkPermission: ["read certification"],
            params: {
              type: 'departure'
            }
          },
          {
            text: "Non visa arrival certification",
            to: {name: "NonVisaArrivalCertification"},
            checkPermission: ["read certification"],
            icon: "mdi-alpha-a-box",
          },
          {
            text: "Non visa departure certification",
            to: {name: "NonVisaDepartureCertification"},
            checkPermission: ["read certification"],
            icon: "mdi-alpha-d-box",
          },
        ]
      },
      {
        icon: "mdi-alpha-v-box",
        text: "Visa Setups",
        model: false,
        children: [
          {
            icon: "view_module",
            text: "Visa Types",
            to: {name: "VisaType"},
            checkPermission: ["read visa-type"]
          },
          {
            icon: "format_align_center",
            text: "Visa Conditions",
            to: {name: "VisaTypeCondition"},
            checkPermission: ["read visa-condition"]
          },
        ]
      },
      {
        icon: "mdi-human",
        text: "Travellers",
        to: {name: "TravellersHistory"},
        checkPermission: ["view traveller-history-list"]
      },
      {
        icon: "mdi-book",
        text: "Documents",
        to: {name: "DocumentRecord"},
        checkPermission: ["read documents"]
      },
      {
        icon: "mdi-sticker",
        text: "Visa Sticker Transaction",
        to: {name: "VisaStickerTransaction"},
        checkPermission: ["read visa-sticker-transaction"]
      },
      {
        icon: "mdi mdi-hiking",
        text: "Trekking",
        model: false,
        children: [
          {
            icon: "mdi mdi-format-list-bulleted-type",
            text: "Trekking Requests",
            to: {name: "TrekkingRequest"},
            checkPermission: ["read trekking-request"]
          },
          {
            icon: "mdi mdi-format-list-bulleted-type",
            text: "Single Trekking Requests",
            to: {name: "SingleTrekkingRequest"},
            checkPermission: ["read trekking-request"]
          },
          {
            icon: "landscape",
            text: "Trekking Agencies",
            to: {name: "TrekkingAgencies"},
            checkPermission: ["read trekking-agency"]
          },
          {
            icon: "people",
            text: "Trekking Agency Users",
            to: {name: "TrekkingAgencyUsers"},
            checkPermission: ["read trekking-agency-user"]
          },
          {
            icon: "mdi-routes",
            text: "Trekking Routes",
            to: {name: "TrekkingRoute"},
            checkPermission: ["read trekking-route"]
          },
          {
            icon: "mdi-clipboard-text-multiple-outline",
            text: "Tippani",
            to: {name: "TrekkingTippani"},
            checkPermission: ["read trekking-tippani"]
          },
        ]
      },
      {
        icon: "mdi-account-multiple",
        text: "Users/Roles/Offices",
        model: false,
        children: [
          {
            icon: "mdi-clipboard-account",
            text: "Users",
            to: {name: "User"},
            checkPermission: ["read user"]
          },
          {
            icon: "verified_user",
            text: "Roles",
            to: {name: "Role"},
            checkPermission: ["read role"]
          },
          {
            icon: "adjust",
            text: "Permissions",
            to: {name: "Permission"},
            checkPermission: ["read permission"]
          },
          {
            icon: "adjust",
            text: "Permission Groups",
            to: {name: "PermissionTypes"},
            checkPermission: ["read permission"]
          },
          {
            icon: "card_travel",
            text: "Offices",
            to: {name: "Office"},
            checkPermission: ["read office"]
          }
        ]
      },
      {
        icon: "mdi-check-all",
        text: "Manual Correction",
        model: false,
        children: [
          {
            icon: "mdi-book",
            text: "Traveller Centralization",
            to: {name: "DocumentCorrection"},
            checkPermission: ["make document-correction"]
          },
          {
            icon: "mdi-account",
            text: "Traveller Info Correction",
            to: {name: "TravellerUpdate"},
            checkPermission: ["alter traveller-record"]
          },
          {
            icon: "mdi-file-document-box-plus-outline",
            text: "Visa Number Correction",
            to: {name: "ChangeVisaNumber"},
            checkPermission: ["alter visa-number"]
          },
          {
            icon: "mdi-file-document-box-plus-outline",
            text: "Manual Visa Entry",
            to: {name: "VisaEntry"},
            checkPermission: ["add visa-record"]
          }
        ]
      },
      {
        icon: "mdi-airplane-takeoff",
        text: "Airport Terminal",
        model: false,
        children: [
          {
            icon: "cancel",
            text: "A/D Cancellation",
            to: {name: "ADCancel"},
            checkPermission: ["read arrival-departure-cancellation"],
          },
          {
            icon: "mdi-airplane-landing",
            text: "Deportation",
            to: {name: "Deportation"},
            checkPermission: ["read deportation"],
          },
          {
            icon: "people",
            text: "Groups",
            to: {name: "TerminalGroup"},
            checkPermission: ["read terminal-group"]
          },
          {
            icon: "people",
            text: "Leave Details",
            to: {name: "LeaveHistory"},
            checkPermission: ["read leave-detail"]
          },
          {
            icon: "alarm",
            text: "Shifts",
            to: {name: "TerminalShift"},
            checkPermission: ["read terminal-shift"]
          },
          {
            icon: "mdi mdi-desktop-classic",
            text: "Terminal Desks",
            to: {name: "TerminalDesk"},
            checkPermission: ["read terminal-desk"]
          },
          {
            icon: "mdi mdi-calendar",
            text: "Duty Schedule",
            to: {name: "ManageSchedule"},
            checkPermission: ["read manage-schedule"]
          },
          {
            icon: "mdi-nature-people",
            text: "Fixed Desk Users",
            to: {name: "TerminalFixedDeskUsers"},
            checkPermission: ["read terminal-fixed-user-desk-menu"]
          },
          {
            icon: "mdi-timer",
            text: "Group Shift Schedule",
            to: {name: "TerminalGroupShift"},
            checkPermission: ["read terminal-group-shift"]
          },
          {
            icon: "airline_seat_recline_normal",
            text: "Airlines",
            to: {name: "Airline"},
            checkPermission: ["read airline"]
          },
          {
            icon: "mdi-airport",
            text: "Airports",
            to: {name: "Airport"},
            checkPermission: ["read airport"]
          },
          {
            icon: "mdi-alphabetical-variant",
            text: "Flight Number",
            to: {name: "FlightNumber"},
            checkPermission: ["read flight-numbers"]
          },
          {
            icon: "mdi-cellphone",
            text: "Duty Notification Number",
            to: {name: "ExtraCellPhone"},
            checkPermission: ["read extra-cell-phone"]
          }
        ]
      },
      {
        icon: "mdi-chart-line",
        text: "Visa Reports",
        model: false,
        children: [
          {
            icon: "mdi-check",
            text: "Visa Issued",
            to: {name: "IssuedVisa"},
            checkPermission: ["read issued-visa"]
          },
          {
            icon: "mdi-check",
            text: "Valid Issued Visa",
            to: {name: "ValidIssuedVisa"},
            checkPermission: ["read valid-issued-visa"]
          },
          {
            icon: "mdi-check",
            text: "Converted Visa",
            to: {name: "ValidConvertedVisa"},
            checkPermission: ["read valid-converted-visa"]
          },
          {
            icon: "mdi-check",
            text: "OverStay Visa Issued",
            to: {name: "OverstayProcessedVisa"},
            checkPermission: ["read overstay-issued-visa"]
          },
          {
            icon: "mdi-check",
            text: "Entry Visa Issued",
            to: {name: "EntryVisa"},
            checkPermission: ["read entry-issued-visa"]
          },
          {
            icon: "mdi-alpha-i-box",
            text: "Visa Issued from Mission",
            to: {name: "MissionIssuedVisa"},
            checkPermission: ["read mission-issued-visa"]
          },
          {
            icon: "mdi-alpha-m-box",
            text: "Manually Entered Visa",
            to: {name: "ManualEntryReport"},
            checkPermission: ["read manual-entry-report"]
          },
          {
            icon: "mdi-cancel",
            text: "Rejected Visa",
            to: {name: "RejectedVisa"},
            checkPermission: ["read rejected-visa"]
          },
          {
            icon: "mdi-file-cancel-outline",
            text: "Cancelled Visa",
            to: {name: "CancelledVisa"},
            checkPermission: ["read cancelled-visa"]
          },
          {
            icon: "mdi-alpha-l-box",
            text: "Visa Expired",
            to: {name: "VisaExpiredReport"},
            checkPermission: ["read late-stay-report"]
          },
          {
            icon: "mdi-check",
            text: "Issued Visa Country Wise",
            to: {name: "IssuedVisaCountryWise"},
            checkPermission: ["read issued-visa-summary-report"]
          },
          {
            icon: "mdi-check",
            text: "Valid Issued Visa Country Wise",
            to: {name: "ValidIssuedVisaCountryWise"},
            checkPermission: ["read valid-issued-visa-summary-report"]
          },
          {
            icon: "mdi-check",
            text: "Issued Visa Office Wise",
            to: {name: "IssuedVisaOfficeWise"},
            checkPermission: ["read issued-visa-summary-report"]
          },
          {
            icon: "mdi-alpha-l-box",
            text: "Visa Expired Country Wise",
            to: {name: "VisaExpiredCountryWise"},
            checkPermission: ["read visa-expired-country-wise-summary-report"]
          },
          {
            icon: "mdi-alpha-l-box",
            text: "Visa Expired Visa Type Wise",
            to: {name: "VisaExpiredVisaTypeWise"},
            checkPermission: ["read visa-expired-visa-type-wise-summary-report"]
          },
        ]
      },
      {
        icon: "mdi-chart-line",
        text: "Revenue Reports",
        model: false,
        children: [
          {
            icon: "mdi-cash-usd-outline",
            text: "Overall Revenue",
            to: {name: "OverallReport"},
            checkPermission: ["read revenue-report"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Visa Revenue",
            to: {name: "RevenueReport"},
            checkPermission: ["read revenue-report"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Trekking Revenue",
            to: {name: "TrekkingRevenueReport"},
            checkPermission: ["read trekking-revenue-report"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "SCP Revenue",
            to: {name: "SCPReport"},
            checkPermission: ["read special-case-payment"]
          },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Officer Revenue",
          //   to: {name: "OfficerRevenueReport"},
          //   checkPermission: ["read officer-revenue-report"]
          // },
          // {
          //   icon: "mdi-check",
          //   text: "Airport Officer Revenue",
          //   to: {name: "AirportOfficerWiserReport"},
          //   checkPermission: ["read airport-officer-wise-daily-report"]
          // },
          // {
          //   icon: "mdi-check",
          //   text: "Section Wise Issued Visa With Revenue",
          //   to: {name: "SectionWiseIssuedVisa"},
          //   checkPermission: ["read section-wise-issued-visa"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Trekking Revenue Route Wise",
          //   to: {name: "TrekkingRouteWise"},
          //   checkPermission: ["read trekking-route-wise-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Trekking Revenue Agency Wise",
          //   to: {name: "TrekkingRevenueAgencyWise"},
          //   checkPermission: ["read trekking-revenue-agency-wise-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Trekking Revenue Office Wise",
          //   to: {name: "TrekkingRevenueOfficeWise"},
          //   checkPermission: ["read trekking-revenue-office-wise-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Country Wise",
          //   to: {name: "RevenueCountryWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Office Wise",
          //   to: {name: "RevenueOfficeWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Section Wise",
          //   to: {name: "RevenueSectionWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Country Wise",
          //   to: {name: "RevenueCountryWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Office Wise",
          //   to: {name: "RevenueOfficeWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Revenue Section Wise",
          //   to: {name: "RevenueSectionWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Office Revenue Head Report",
          //   to: {name: "OfficeRevenueHead"},
          //   checkPermission: ["read office-revenue-head-summary-report"]
          // },
        ]
      },
      {
        icon: "mdi-chart-line",
        text: "A/D Reports",
        model: false,
        children: [
          {
            icon: "mdi-airplane-landing",
            text: "Arrival/Departure Report",
            to: {name: "ArrivalDepartureReport"},
            checkPermission: ["read arrived-report"]
          },
          {
            icon: "mdi-airplane-off",
            text: "Offload Report",
            to: {name: "OffloadReport"},
            checkPermission: ["read offload-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "Reload Report",
            to: {name: "ReloadReport"},
            checkPermission: ["read reload-report"]
          },
          {
            icon: "mdi-stop-circle-outline",
            text: "Entry Refuse Report",
            to: {name: "EntryRefuseReport"},
            checkPermission: ["read entry-refuse-report"]
          },
          {
            icon: "mdi-stop-circle-outline",
            text: "Nepalese Entry Refuse Report",
            to: {name: "NepaleseEntryRefuseReport"},
            checkPermission: ["read entry-refuse-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "A/D Country Wise",
            to: {name: "ADCountryWiseReport"},
            checkPermission: ["read arrival-departure-summary-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "A/D Office Wise",
            to: {name: "ADOfficeWiseReport"},
            checkPermission: ["read arrival-departure-summary-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "A/D Officer Wise",
            to: {name: "ADOfficerWiseReport"},
            checkPermission: ["read arrival-departure-summary-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "Nepalese A/D Country Wise",
            to: {name: "NepaleseADCountryWiseReport"},
            checkPermission: ["read nepalese-arrival-departure-summary-report"]
          },
          {
            icon: "mdi-airplane-landing",
            text: "Deportation",
            to: {name: "Deportation"},
            checkPermission: ["read deportation"],
          },
        ]
      },
      {
        icon: "mdi-chart-line",
        text: "Summary Reports",
        model: false,
        children: [
          {
            icon: "mdi-airplane-landing",
            text: "A/D Report",
            to: {name: "summaryAdReport"},
            checkPermission: ["read summary-report-ad"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Revenue Country Wise",
            to: {name: "summaryRevenueCountryReport"},
            checkPermission: ["read summary-report-revenue-country"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Revenue Office Wise",
            to: {name: "summaryRevenueOfficeReport"},
            checkPermission: ["read summary-report-revenue-office"]
          },
          {
            icon: "mdi-stop-circle-outline",
            text: "Visa Country Wise",
            to: {name: "summaryVisaCountryReport"},
            checkPermission: ["read summary-report-visa-country"]
          },
          {
            icon: "mdi-stop-circle-outline",
            text: "Visa Office Wise",
            to: {name: "summaryVisaOfficeReport"},
            checkPermission: ["read summary-report-visa-office"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Visa Visit Revenue",
            to: {name: "summaryVisaVisitReport"},
            checkPermission: ["read summary-report-visa-visit-revenue"]
          },
          {
            icon: "mdi-file",
            text: "Statistics",
            to: {name: "summaryStatisticReport"},
            checkPermission: ["read summary-report-statistics"]
          },
        ]
      },
      {
        icon: "mdi-chart-line",
        text: "Other Reports",
        model: false,
        children: [
          {
            icon: "mdi-human",
            text: "Travellers Scan",
            to: {name: "TravellersScanReport"},
            checkPermission: ["read traveller-scan-report"]
          },
          {
            icon: "mdi-human",
            text: "Travellers Staying In Nepal",
            to: {name: "TravellersStayingInNepalHistory"},
            checkPermission: ["view traveller-staying-in-nepal-history-list"]
          },
          {
            icon: "mdi-alpha-o-box",
            text: "Overstay",
            to: {name: "OverStayReport"},
            checkPermission: ["read over-stay-report"]
          },
          {
            icon: "mdi-alpha-p-box",
            text: "Previous Stay",
            to: {name: "PreviousStayReport"},
            checkPermission: ["read previous-stay-report"]
          },
          {
            icon: "mdi-chart-line-stacked",
            text: "Trekkers",
            to: {name: "TrekkersReport"},
            checkPermission: ["read trekkers-report"]
          },
          {
            icon: "mdi-chart-line-stacked",
            text: "BlackList Delisted",
            to: {name: "BlackDelistReport"},
            checkPermission: ["read blacklist-delist-report"]
          },
          {
            icon: "mdi-book",
            text: "Documents Watchlist",
            to: {name: "WatchListDocumentReport"},
            checkPermission: ["read watchlist-document"]
          },
          {
            icon: "mdi-alpha-c-box",
            text: "Certification Report",
            to: {name: "CertificationReport"},
            checkPermission: ["read certification"]
          },
          {
            icon: "mdi-alpha-c-box",
            text: "Non Visa Certification Report",
            to: {name: "NonVisaCertificationReport"},
            checkPermission: ["read certification"]
          },
          {
            icon: "mdi-currency-usd",
            text: "Local Currency Setup",
            to: {name: "LocalCurrencyReport"},
            checkPermission: ["read local-currency-report"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "SCP Report",
            to: {name: "SCPReport"},
            checkPermission: ["read special-case-payment"]
          },
          {
            icon: "mdi-cellphone",
            text: "Mobile Devices",
            to: {name: "MobileDeviceReport"},
            checkPermission: ["read mobile-device-report"]
          },
          {
            icon: "mdi-account",
            text: "TSIN Country Wise",
            to: {name: "TravellerStayingInNepalReport"},
            checkPermission: ["read traveller-staying-in-nepal-summary-report"]
          },
          {
            icon: "mdi-account",
            text: "TSIN Visa Type Wise",
            to: {name: "TravellerStayingInNepalVisaTypeWiseReport"},
            checkPermission: ["read traveller-staying-in-nepal-summary-report"]
          },
          {
            icon: "mdi-account",
            text: "Trekkers Country Wise",
            to: {name: "TrekkersCountryWise"},
            checkPermission: ["read trekkers-country-wise-summary-report"]
          },
          // {
          //   icon: "mdi-cash-usd-outline",
          //   text: "Integrated Revenue Report",
          //   to: {name: "RevenueOfficeTypeWise"},
          //   checkPermission: ["read revenue-summary-report"]
          // },
          {
            icon: "mdi-account",
            text: "Traveller Report",
            to: {name: "TravellerSummary"},
            checkPermission: ["read traveller-summary-report"]
          },
          {
            icon: "mdi-target-account",
            text: "Departure Purpose Report",
            to: {name: "DeparturePurposeSummary"},
            checkPermission: ["read departure-purpose-summary-report"]
          },
          {
            icon: "mdi-target-account",
            text: "Multiple Arrival Departure Travellers",
            to: {name: "multipleArrivalDepartureReport"},
            checkPermission: ["read departure-purpose-summary-report"]
          },
          // {
          //   icon: "mdi-target-account",
          //   text: "Working Visa Report",
          //   to: {name: "workingVisaReport"},
          //   checkPermission: ["read traveller-summary-report"]
          // }
        ]
      },
      {
        icon: "mdi-playlist-edit",
        text: "Dynamic Values",
        model: false,
        children: [
          {
            icon: "mdi-office-building",
            text: "User Section",
            to: {name: "UserSection"},
            checkPermission: ["read user-section"],
          },
          {
            icon: "mdi-briefcase",
            text: "User Designation",
            to: {name: "UserDesignation"},
            checkPermission: ["read user-designation"],
          },
          {
            icon: "mdi-passport",
            text: "Purpose of Visa",
            to: {name: "PurposeOfVisa"},
            checkPermission: ["read dynamic-values-setup"],
          }, {
            icon: "mdi-taxi",
            text: "Purpose of Arrival",
            to: {name: "PurposeOfArrival"},
            checkPermission: ["read dynamic-values-setup"],
          }, {
            icon: "mdi-taxi",
            text: "Purpose of Departure",
            to: {name: "PurposeOfDeparture"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-account-switch",
            text: "Blacklist Category",
            to: {name: "BlackListReason"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-email",
            text: "User visa application mail",
            to: {name: "VisaApplicationMail"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-account-switch",
            text: "Relations",
            to: {name: "Relations"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-briefcase",
            text: "Occupations",
            to: {name: "Occupations"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-account-convert",
            text: "Reason for conversion",
            to: {name: "ReasonForConversion"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-arrow-expand",
            text: "Reason for extension",
            to: {name: "ReasonForExtension"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-certificate",
            text: "Reason for Certification",
            to: {name: "ReasonForCertification"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-transfer",
            text: "Reason for transfer",
            to: {name: "ReasonForTransfer"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-alpha-v-box",
            text: "Reason for blacklisting visa-sticker",
            to: {name: "ReasonForVisaStickerBlacklist"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-alpha-c-box",
            text: "Document Category",
            to: {name: "documentCategory"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-file",
            text: "Category for muddha",
            to: {name: "MuddhaCategory"},
            checkPermission: ["read muddha-category"],
          },
          {
            icon: "mdi-file",
            text: "Desk Groups",
            to: {name: "DeskGroup"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-book",
            text: "College",
            to: {name: "College"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-office-building",
            text: "Company",
            to: {name: "Company"},
            checkPermission: ["read dynamic-values-setup"],
          },
          {
            icon: "mdi-office-building",
            text: "Trekking Agency",
            to: {name: "trekkingAgancy"},
            checkPermission: ["read dynamic-values-setup"],
          },
        ]

      },
      // {
      //   icon: "mdi-alpha-a-box",
      //   text: "Appointment",
      //   model: false,
      //   children: [
      //     {
      //       icon: "mdi-alpha-t-box",
      //       text: "Token",
      //       to: {name: "AppointmentToken"},
      //       checkPermission: ["read appointment_token"]
      //     },
      //     {
      //       icon: "mdi-alpha-s-box",
      //       text: "Shift",
      //       to: {name: "AppointmentShift"},
      //       checkPermission: ["read appointment_shift"]
      //     },
      //     {
      //       icon: "mdi-alpha-r-box",
      //       text: "Report",
      //       to: {name: "AppointmentReport"},
      //       checkPermission: ["read appointment_report"]
      //     },
      //     {
      //       icon: "mdi-alpha-b-box",
      //       text: "Summary Report",
      //       to: {name: "AppointmentSummary"},
      //       checkPermission: ["read appointment_report"]
      //     },
      //   ]
      // },
      {
        icon: "mdi-alpha-l-box",
        text: "Logs",
        model: false,
        children: [
          {
            icon: "mdi-settings",
            text: "Setting Change Logs",
            to: {name: "SettingLogsReport"},
            checkPermission: ["read setting-logs-report"]
          },
          {
            icon: "mdi-settings",
            text: "Visa Number Change Logs",
            to: {name: "VisaNumberChangeLogReport"},
            checkPermission: ["read visa-number-changelog"]
          },
          {
            icon: "mdi-account-clock-outline",
            text: "Activity Logs",
            to: {name: "ActivityLog"},
            checkPermission: ["read activity-log"]
          },
          {
            icon: "mdi-message-text-clock-outline",
            text: "Sms logs",
            to: {name: "SMSLog"},
            checkPermission: ["read sms-log"]
          }
        ]
      },
      {
        icon: "mdi-alpha-m-box",
        text: "Muddha",
        model: false,
        children: [
          {
            icon: "mdi-file-document-box-plus-outline",
            text: "New Muddha Entry",
            to: {name: "NewMuddha"},
            checkPermission: ["add muddha"]
          },
          {
            icon: "mdi-file-document-box-plus-outline",
            text: "Muddha Entry Report",
            to: {name: "MuddhaEntryReport"},
            checkPermission: ["read muddha"]
          },
          // {
          //   icon: "mdi-file-document-box-plus-outline",
          //   text: "Traveller New Entry",
          //   to: {name: "NewTravellerEntry"},
          //   checkPermission: ["add traveller"]
          // },
        ]
      },
      {
        icon: "mdi-certificate",
        text: "Sram/NOC/Consular Check",
        model: false,
        children: [
          {
            icon: "mdi-certificate",
            text: "NOC Check",
            to: {name: "NocCheck"},
            checkPermission: ["read noc-number"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Labour Permit Check",
            to: {name: "DofePassportCheck"},
            checkPermission: ["read dofe-passport"]
          },
          {
            icon: "mdi-alpha-c-box",
            text: "Consular Visa Check",
            to: {name: "ConsularVisaCheck"},
            checkPermission: ["read consular-visa"]
          },
          {
            icon: "mdi-file-account",
            text: "Citizenship Check",
            to: {name: "CimsCitizenCheck"},
            checkPermission: ["read cims-citizenship-check"]
          },
          {
            icon: "mdi-alpha-d-box",
            text: "Self Declaration Check",
            to: {name: "ImmiSelfDeclarationCheck"},
            checkPermission: ["read immi-self-declaration-check"]
          },
          {
            icon: "mdi-alpha-c-box",
            text: "VISA RECOMMENDATION SEARCH",
            to: {name: "VisaRecommendationSearch"},
            checkPermission: ["read consular-visa"]
          },
        ]
      },
      {
        icon: "mdi-account-multiple-minus",
        text: "Blacklist Records",
        to: {name: "Blacklist"},
        checkPermission: ["read blacklist"]
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "Watchlist Records",
        to: {name: "WatchList"},
        checkPermission: ["read watchlist"]
      },
      {
        icon: "mdi-account-multiple-minus",
        text: "Interpol Check",
        to: {name: "InterpolCheck"},
        checkPermission: ["read interpol-service"]
      },
      {
        icon: "mdi-airplane-takeoff",
        text: "Flight Check",
        to: {name: "DomesticFlight"},
        checkPermission: ["read domestic-flight-service"]
      },

      // {
      //     icon: "mdi-certificate",
      //     text: "NOC list",
      //     to: {name: "Noc"},
      //     checkPermission: ["read noc"]
      // },
      // {
      //   icon: "mdi-ticket",
      //   text: "Support Tickets",
      //   to: {name: "SupportTickets"},
      //   checkPermission: ["read support-ticket"]
      // },

      {
        icon: "mdi-alpha-s-box",
        text: "Service Provider",
        model: false,
        children: [
          {
            icon: "mdi-alpha-s-box",
            text: "Service Provider",
            to: {name: "ServiceProvider"},
            checkPermission: ["read service-provider"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Service Provider Type",
            to: {name: "ServiceProviderType"},
            checkPermission: ["read service-provider-type"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Service Provider Type Purpose",
            to: {name: "ServiceProviderTypePurpose.vue"},
            checkPermission: ["read service-provider-type-purpose"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Service Provider Report",
            to: {name: "ServiceProviderReport.vue"},
            checkPermission: ["read service-provider"]
          },
        ]
      },
      {
        icon: "mdi-playlist-plus",
        text: "Other",
        model: false,

        children: [
          {
            icon: "mdi-cash-usd-outline",
            text: "Manual Voucher Generation",
            to: {name: "ManualVoucherGeneration"},
            checkPermission: ["read manual-voucher-generation"]
          },
          {
            icon: "mdi-cash-usd-outline",
            text: "Manual Check Payment Status",
            to: {name: "ManualCheckPaymentStatus"},
            checkPermission: ["read manual-check-payment-status"]
          },
          {
            icon: "mdi-alpha-p-box",
            text: "Previous Stay Calculate",
            to: {name: "PreviousStayCheckStatus"},
            checkPermission: ["read manual-check-payment-status"]
          },
          {
            icon: "mdi mdi-image",
            text: "Sliders",
            to: {name: "Slider"},
            checkPermission: ["read slider"]
          },
          {
            icon: "mdi mdi-message-image-outline",
            text: "Notices",
            to: {name: "Notice"},
            checkPermission: ["read notice"]
          },
          {
            icon: "mdi-flag",
            text: "Countries",
            to: {name: "Country"},
            checkPermission: ["read country"]
          },
          {
            icon: "mdi-bookshelf",
            text: "Documents Store",
            to: {name: "DocumentStore"},
            checkPermission: ["read document-store"]
          },
          {
            icon: "mdi-clipboard-text-multiple-outline",
            text: "Tippani Type",
            to: {name: "Tippani"},
            checkPermission: ["read tippani"]
          },
          {
            icon: "format_align_center",
            text: "Document Type",
            to: {name: "DocumentType"},
            checkPermission: ["read document-type"]
          },
          // {
          //   icon: "mdi-bank",
          //   text: "Banks",
          //   to: {name: "Bank"},
          //   checkPermission: ["read bank"]
          // },
          // {
          //     icon: "mdi-access-point",
          //     text: "Access Ip",
          //     to: {name: "AccessIp"},
          //     checkPermission: ["read access-ip"]
          // },

          {
            icon: "mdi-calendar-check",
            text: "Fiscal Years",
            to: {name: "FiscalYear"},
            checkPermission: ["read fiscal-year"]
          },
          {
            icon: "mdi-account-group",
            text: "Stakeholder",
            to: {name: "Stakeholder"},
            checkPermission: ["read stakeholder"]
          },
          {
            icon: "mdi-access-point-network",
            text: "Stakeholder Api",
            to: {name: "StakeholderApi"},
            checkPermission: ["read stakeholder-api"]
          },
          // {
          //   icon: "mdi-sticker",
          //   text: "Sticker number",
          //   to: {name: "Sticker"},
          //   checkPermission: ["read sticker"]
          // },
          // {
          //   icon: "mdi-alpha-b-box",
          //   text: "Blacklist Sticker number",
          //   to: {name: "BlacklistVisaSticker"},
          //   checkPermission: ["read blacklist-visa-sticker"]
          // },
          {
            icon: "mdi-cellphone-message",
            text: "Send SMS",
            to: {name: "SMSSend"},
            checkPermission: ["send sms"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Special Case Payment",
            to: {name: "SCPList"},
            checkPermission: ["read special-case-payment"]
          },
          {
            icon: "mdi-alpha-s-box",
            text: "Override Overstay",
            to: {name: "OverstayApplication"},
            checkPermission: ["read overstay-application"]
          },
          // {
          //   icon: "mdi-account-multiple-plus",
          //   text: "Viplist Records",
          //   to: {name: "Viplist"},
          //   checkPermission: ["read watchlist"]
          // },
          {
            icon: "mdi-file-document",
            text: "Recommendation letters",
            to: {name: "RecommendationLetter"},
            checkPermission: ["read recommendation-letter"]
          },
        ]
      },
      {
        icon: "mdi-map-marker",
        text: "Address",
        model: false,
        children: [
          {
            icon: "mdi-city",
            text: "State",
            to: {name: "State"},
            checkPermission: ["read state"]
          },
          {
            icon: "mdi-city",
            text: "District",
            to: {name: "District"},
            checkPermission: ["read district"]
          },
          {
            icon: "mdi-city",
            text: "Municipality",
            to: {name: "City"},
            checkPermission: ["read city"]
          }
        ]
      },
      {
        icon: "mdi-alpha-s-box",
        text: "Dynamic Routes",
        model: false,
        children: [
          {
            icon: "mdi-alpha-s-box",
            text: "List Dynamic Routes",
            to: {name: "DynamicRoutes"},
            checkPermission: ["read service-provider"]
          },
        ]
      },

    ],

    document_number: null
  }),
  computed: {
    moment() {
      return moment
    },
    ...mapGetters("Notification", ["snackbar"]),
    ...mapGetters("AuthUser", ["user"]),
    ...mapGetters("VisaRequestSingle", ["assignedVisas"]),
    ...mapGetters("TrekkingSingle", ["assignedTrekkingRequests"]),
    loading: {
      get() {
        return this.$store.state.VisaRequestSingle.loading
      }
    },
    password_change_required() {
      if (this.user)
        return this.user.password_change_required;

      return false;
    },
    filterDrawer: {
      get() {
        return this.$store.state.Notification.filterDrawer;
      },
      set(value) {
        if (!value) {
          this.$store.commit('Notification/toggleFilterDrawer')
        }
      }
    },
    roles() {
      let roles = "";
      this.user.roles.forEach((role, i) => {
        roles += role.display_name;
        if (i + 1 < this.user.roles.length)
          roles += " ,";
      });
      return roles;
    }
  },
  methods: {
    ...mapActions("AuthUser", ["fetchCurrentUser"]),
    ...mapActions("VisaRequestSingle", ["getAssignedVisas"]),
    ...mapActions("TrekkingSingle", ["getAssignedTrekkingRequests"]),
    handleClose() {

    },
    isDateToday(date) {
      return moment(date).isSame(moment(), 'day')
    },
    async logoutNow() {
      await Http.post(`${API_URL}${VERSION}/logout`);
      oAuth.logout();
      this.$router.go({name: "Login"});
    },
    showMenu(item) {
      let show_menu = false;
      let permissions = item.checkPermission;
      let user = this.user;

      if (user.roles) {
        const user_permissions = user.permissions;


        if (user.roles[0].name === "Super Admin")
          return true;

        for (let permission of permissions) {
          for (let user_permission of user_permissions) {
            if (permission === user_permission.name) {
              show_menu = true;
              break;
            }
          }
        }
      }
      return show_menu;
    },
    showChild(item) {
      let show_menu = false;

      let user = this.user;
      if (user.roles) {

        let children = item.children;
        let user_permissions = user.permissions;
        if (children !== undefined) {
          if (user.roles[0].name === "Super Admin")
            return true;

          for (let child of children) {
            let permissions = child.checkPermission;
            for (let permission of permissions) {
              for (let user_permission of user_permissions) {
                if (permission === user_permission.name) {
                  show_menu = true;
                  break;
                }
              }
            }
          }
        }
      }
      return show_menu;
    },
    routeTo(to, params = null) {

      if (params) {
        to.params = params;
        this.$router.push(to).catch((e) => {
        });
      } else {
        this.$router.push(to).catch((e) => {
        });
      }
    },
    openTravellerDocuments() {
      let routeData = this.$router.resolve({name: 'DocumentRecord', query: {'document_number': this.document_number}});
      this.document_number = null
      window.open(routeData.href, '_blank');
    },
    viewVisaRequest(item) {
      this.$router.push({name: 'ViewVisaRequest', params: {id: item.submission_no}});
      // let routeData = this.$router.resolve({name: 'ViewVisaRequest', params: {id: item.submission_no}});
      // window.open(routeData.href, '_blank');
    },
    viewTrekkingRequest(item) {
      console.log('item',item.id);
      this.$router.push({name: 'ViewTrekkingRequest', params: {id: item.id}});
      // let routeData = this.$router.resolve({name: 'ViewVisaRequest', params: {id: item.submission_no}});
      // window.open(routeData.href, '_blank');
    },
    fetchAssignedVisa() {
      this.getAssignedVisas().then(res => {
        this.assignedVisasTotal = res.total
      });
    },
    fetchAssignedTrekkingRequests() {
      this.getAssignedTrekkingRequests().then(res => {
        this.assignedTrekkingRequestsTotal = res.total
      });
    },
    refreshNotification() {
      if (!!this.user.automation_enabled) {
        this.fetchAssignedVisa();
      }
      if (!!this.user.automation_trekking) {
        this.fetchAssignedTrekkingRequests()
      }
    }
  },
  mounted() {
    this.fetchCurrentUser();
    this.refreshNotification();

    this.itemSide = [

      {
        icon: "account_circle",
        title: "Profile",
        show: true,
        click: () => {
          this.$router.push({name: "Profile"});
        }
      },
      {
        icon: "mdi-two-factor-authentication",
        title: "2FA",
        show: true,
        click: () => {
          this.$router.push({name: "2FA"});
        }
      },
      {
        icon: "mdi-settings",
        title: "Settings",
        show: this.$oauth.checkIfHasPermission('read settings'),
        click: () => {
          this.$router.push({name: "Setting"});
        }
      },
      {
        icon: "logout",
        title: "Logout",
        show: true,
        click: () => {
          this.logoutNow();
        }
      }
    ];
  }
};
</script>


<style>
.search-btn-for-sm {
  display: none;
}

@media screen and (max-width: 768px) {
  .search-btn-for-sm {
    display: block;
  }
}

.notify-bell {
  animation: bell 1.5s 1.5s both infinite;
}

@keyframes bell {
  0% {
    transform: rotate(0);
  }
  10% {
    transform: rotate(30deg);
  }
  20% {
    transform: rotate(0);
  }
  80% {
    transform: rotate(0);
  }
  90% {
    transform: rotate(-30deg);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
